import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "../styling/login.css";
import { useHistory } from "react-router-dom";
import AuthService from "../services/auth";
import "../styling/sidebar.css";
import ReactGA from "react-ga";
import Mode from "../components/Mode";

interface ForgotProps {}

export const Forgot: React.FC<ForgotProps> = ({}) => {
  ReactGA.pageview(window.location.pathname);
  const history = useHistory();
  const [email, setEmail] = useState("");

  function validateForm() {
    return email.length > 0;
  }
  const eventTrackLogin = (category, action, label) => {
    //console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      AuthService.forgotPassword(email).then(() => {
        eventTrackLogin("Forogot Password", "Forgot Password", "Button");
        alert("Please check your mail!!")
      });
    } catch (e) {}
  };
  return (
    <>
    <div className="Login">
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="email">
          <Form.Label className="forgot-email">Email</Form.Label>
          <Form.Control
            autoFocus
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <div
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}
        >
          <Button
            className="login-button"
            block
            size="lg"
            type="submit"
            disabled={!validateForm()}
          >
            Forgot Password
          </Button>
        </div>
        Don't have an account? <a href="/auth/register">Register here</a>
      </Form>
    </div>
    <Mode/>
    </>
  );
};
